import { render, staticRenderFns } from "./matchingList.vue?vue&type=template&id=6a829ece&scoped=true"
import script from "./matchingList.vue?vue&type=script&lang=js"
export * from "./matchingList.vue?vue&type=script&lang=js"
import style0 from "./matchingList.vue?vue&type=style&index=0&id=6a829ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a829ece",
  null
  
)

export default component.exports